module.exports = __webpack_public_path__ + "static/media/tour-popup-1-fig.f6d3dc4e.png";